export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      5754.195011337869,
    ],
    button_spin: [
      7000,
      999.9092970521541,
    ],
    end_free_spin: [
      9000,
      5542.312925170069,
    ],
    free_bet_big_win: [
      16000,
      1377.2335600907013,
    ],
    free_bet_mega_win: [
      19000,
      2213.151927437643,
    ],
    free_bet_total_win: [
      23000,
      979.591836734695,
    ],
    free_bet_ultra_win: [
      25000,
      1319.1836734693893,
    ],
    free_spin_ambient: [
      28000,
      41872.834467120185,
    ],
    free_spin_music: [
      71000,
      93306.48526077096,
    ],
    free_spin_popup: [
      166000,
      6366.621315192731,
    ],
    free_spin_start: [
      174000,
      7974.603174603175,
    ],
    inside_buttons: [
      183000,
      436.8253968253839,
    ],
    main_ambient: [
      185000,
      64732.87981859408,
    ],
    main_music: [
      251000,
      174576.32653061228,
    ],
    mega_win: [
      427000,
      6862.947845804967,
    ],
    mult_x1: [
      435000,
      1934.5124716553528,
    ],
    mult_x3: [
      438000,
      2259.5918367346712,
    ],
    mult_x5: [
      442000,
      2532.4263038548906,
    ],
    mult_x7: [
      446000,
      1795.1927437641757,
    ],
    mult_x9: [
      449000,
      2782.0408163265142,
    ],
    outside_buttons: [
      453000,
      428.1179138321818,
    ],
    reel_spin: [
      455000,
      2282.81179138321,
    ],
    reel_stop_01: [
      459000,
      291.7006802721289,
    ],
    reel_stop_02: [
      461000,
      291.7006802721289,
    ],
    reel_stop_03: [
      463000,
      265.57823129252256,
    ],
    reel_stop_04: [
      465000,
      245.26077097505095,
    ],
    reel_stop_05: [
      467000,
      261.2244897958931,
    ],
    regular_win: [
      469000,
      1055.0566893423934,
    ],
    scatter_chance: [
      472000,
      3095.51020408162,
    ],
    scatter_chance_lose: [
      477000,
      6880.362811791372,
    ],
    scatter_chance_win: [
      485000,
      9211.065759637166,
    ],
    scatter_stop: [
      496000,
      2474.376417233543,
    ],
    tap_to_play: [
      500000,
      9777.052154195018,
    ],
    ultra_win: [
      511000,
      7936.87074829927,
    ],
  },
}
